/**
 * Subscription Cancelled Page
 *
 * Shows message when user cancels Stripe checkout
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import Layout from '../../components/Layout';

const SubscriptionCancelled: React.FC = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/subscription/pricing');
  };

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto text-center py-12">
        {/* Cancel Icon */}
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-600" />
        </div>

        {/* Cancel Message */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Subscription Cancelled</h1>

        <p className="text-gray-600 mb-8">
          Your subscription process was cancelled. No charges were made to your account.
        </p>

        <p className="text-sm text-gray-500 mb-8">
          You can try again anytime or continue with your current plan.
        </p>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={handleTryAgain}
            className="w-full inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </button>

          <button
            onClick={handleGoBack}
            className="w-full inline-flex items-center justify-center px-6 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </button>
        </div>

        {/* Help Text */}
        <div className="mt-8">
          <p className="text-xs text-gray-500">
            Need help? Contact our support team for assistance with your subscription.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default SubscriptionCancelled;
